// redux_files/liveSalesSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../utils/axiosAuth"; // axios مع تجديد التوكن

const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:8000";

export const fetchBranchesSales = createAsyncThunk(
  "liveSales/fetchBranchesSales",
  async (_, thunkAPI) => {
    try {
      const response = await api.get(`${API_BASE}/api/LiveSalesToday`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Fetch error");
    }
  }
);

export const fetchItemsSales = createAsyncThunk(
  "liveSales/fetchItemsSales",
  async (_, thunkAPI) => {
    try {
      const response = await api.get(`${API_BASE}/api/LiveItemsSalesToday`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Fetch error");
    }
  }
);

export const fetchNetSales = createAsyncThunk(
  "liveSales/fetchNetSales",
  async (_, thunkAPI) => {
    try {
      const response = await api.get(`${API_BASE}/api/LiveNetSalesToday`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Fetch error");
    }
  }
);

const liveSalesSlice = createSlice({
  name: "liveSales",
  initialState: {
    branchesSales: [],
    itemsSales: [],
    netSalesHistory: [],
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBranchesSales.fulfilled, (state, action) => {
        const timestamp = new Date().toISOString().slice(0, 19);
        state.branchesSales = action.payload.map((item) => ({
          ...item,
          time: timestamp,
        }));
      })
      .addCase(fetchItemsSales.fulfilled, (state, action) => {
        const timestamp = new Date().toISOString().slice(0, 19);
        state.itemsSales = action.payload.map((item) => ({
          ...item,
          time: timestamp,
        }));
      })
      .addCase(fetchNetSales.fulfilled, (state, action) => {
        const newPoint = {
          time: action.payload.timestamp,
          value: action.payload.net_sales,
        };
        state.netSalesHistory.push(newPoint);
        if (state.netSalesHistory.length > 1000) {
          state.netSalesHistory.shift();
        }
      })
      .addMatcher(
        (action) => action.type.endsWith("/rejected"),
        (state, action) => {
          state.error = action.payload;
        }
      );
  },
});

export default liveSalesSlice.reducer;
